import { AxiosInstance } from 'axios';
import { BaseRequest } from '@trukt/types/BaseRequest';
import { BaseRequestEndpoints } from '@trukt/types/BaseRequestEndpoints';
import { PaginatedQueryParams } from '@trukt/types/PaginatedQueryParams';
import { SimplePaginatedResults } from '@trukt/types/PaginatedResults';
import { Account, AccountTypeLiterals } from '@trukt/types/Account';
import { AccountContactService } from './services';

interface AccountSearchRequestQueryParams extends Omit<PaginatedQueryParams, 'order'> {
  active?: boolean;
}

export type AccountSearchTypeLiterals = AccountTypeLiterals;

export type AccountSearchRequestRouteParams = {
  type: AccountSearchTypeLiterals;
};

export type AccountSearchRequest = BaseRequest<
  AccountSearchRequestQueryParams,
  void,
  AccountSearchRequestRouteParams
>;

export type AccountSearchResponse = SimplePaginatedResults<Account>;

export type GetAccountRequest = Pick<
  BaseRequest<void, void, { type: AccountTypeLiterals; guid: string }>,
  'routeParams'
>;
export type GetAccountResponse = Account;

export type AccountUpdateRequest = BaseRequest<
  void,
  Pick<Account, 'name' | 'email' | 'isActive' | 'phoneNumber' | 'mobileNumber'>,
  { clientGuid: string }
>;

export class AccountService implements Pick<BaseRequestEndpoints, 'search'> {
  instance: AxiosInstance;
  contact: AccountContactService;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
    this.contact = new AccountContactService(instance);
  }

  getById({ routeParams }: GetAccountRequest) {
    return this.instance.get<GetAccountResponse>(
      `/account/${routeParams.type}/${routeParams.guid}`,
    );
  }

  search(request: AccountSearchRequest) {
    return this.instance.get<AccountSearchResponse>(`/account/${request.routeParams.type}`, {
      params: request.queryParams,
    });
  }

  update({ routeParams, body }: AccountUpdateRequest) {
    return this.instance.put<void>(`/account/${routeParams.clientGuid}`, body);
  }
}
